import { CONTACT_EMAIL, CONTACT_PHONE } from '../constants/business';

export const ADHD_CONTACT_PHONE = '(03) 9034 9950';
export const ADHD_CONTACT_EMAIL = 'adhd@telecare.com.au';

/** Who the patient should contact: the ADHD team for the ADHD pathway, otherwise Telecare. */
export const getContactDetails = ({ isAdhdPathway } = {}) =>
  isAdhdPathway
    ? { phone: ADHD_CONTACT_PHONE, email: ADHD_CONTACT_EMAIL }
    : { phone: CONTACT_PHONE, email: CONTACT_EMAIL };
